import React, { useState } from "react";
import styles from "./MainEventItem.module.css"; // New CSS module for the header
import { CalendarReminderType, CaretakerRequest, PlaydateInvite } from "../../gql/types";
import { ActionType } from "components/action/types";
import ActionButton from "components/button/ActionButton";
import { useToastContext } from "contexts/ToastContext";
import PlaydateInviteOrganizerCreationWorkflow from "components/playdate/workflow/PlaydateInviteOrganizerCreationWorkflow";

type EventSummary = {
    eventID: string;
    title: string;
    startDate: string;
    endDate?: string | null;
    caretakerRequests?: CaretakerRequest[] | null;
    reminderType?: CalendarReminderType | null;
};

type MainEventItemProps = {
    event: EventSummary;
    possibleActions?: ActionType[];
    hasNoConfirmedPlaydateInvites?: boolean;
};

const MainEventItem: React.FC<MainEventItemProps> = ({ event, possibleActions, hasNoConfirmedPlaydateInvites = false }) => {
    const [showInviteCreationView, setShowInviteCreationView] = useState(false);
    const { triggerToastEvent } = useToastContext();

    const formatTime = (dateString: string) => {
        const date = new Date(dateString);
        const options: Intl.DateTimeFormatOptions = {
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
        };
        return date.toLocaleTimeString(undefined, options);
    };

    const handleOpenInviteCreation = () => {
        setShowInviteCreationView(true);
    };

    return (
        <div key={event.eventID} className={`${styles.mainEventItem} ${styles.eventItem}`}>
            <div className={styles.eventItemCardRow}>
                <div className={styles.eventItemLeftSection}>
                    <div className={styles.evenItemtTitle}>{event.title || "Main Event"}</div>
                </div>
                <div className={styles.eventItemRightSection}>
                    <div className={styles.eventItemTime}>
                        {formatTime(event.startDate)}{event.endDate ? ` - ${formatTime(event.endDate)}` : ""}
                    </div>
                </div>
            </div>
            {event.caretakerRequests && event.caretakerRequests.length > 0 && (<div className={styles.eventItemCardRow}>
                <div className={styles.eventItemLeftSection}>
                    <div className={styles.caretakerRequestsContainer}>
                        {event.caretakerRequests.map((request) => (
                            <div key={request.requestID} className={styles.caretakerRequestItem}>
                                <div className={styles.caretakerRequestLabel}>
                                    Childcare Provider: {request.confirmed
                                        ? (request.caretakers && request.caretakers.length > 0
                                            ? request.caretakers[0]?.name
                                            : "Confirmed"
                                        )
                                        : "Request Sent (TBD)"}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            )}
            <div className={`${styles.eventItemCardRow} ${styles.smallerPaddingRow}`}>
                <div className={styles.interactionButtonContainer}>
                    {hasNoConfirmedPlaydateInvites && event.reminderType === CalendarReminderType.SchoolClosure && <ActionButton
                        onClick={handleOpenInviteCreation}
                        textSize="smaller"
                    >
                        Create Playdate Invite
                    </ActionButton>}
                </div>
            </div>

            {showInviteCreationView && (
                <PlaydateInviteOrganizerCreationWorkflow
                    onBack={() => setShowInviteCreationView(false)}
                    featureParameters={{
                        date: event.startDate,
                        eventID: event.eventID,
                    }}
                    onDataChange={(success: boolean, invite?: PlaydateInvite) => {
                        if (success) {
                            triggerToastEvent();
                        }
                    }}
                />
            )}
        </div>
    );
};

export default MainEventItem;
